export default __webpack_public_path__ + "static/media/robotics.1c49dc77.svg";